import Tool from "./Tool";

export default class LayerShapeBaseTool extends Tool {
    constructor(editor) {
        super(editor);
    }

    handleZoom(layer) {
        return;

        this.render(layer);
    }

    createLayerShape(coords, layer, type) {
        const layerShape = {
            type,
            get state() {
                return layer.state;
            },
            get static() {
                return layer.static;
            },
            get visible() {
                return layer.visible;
            },
            // get translate() {
            //     return layer.translate;
            // },
            get translations() {
                return layer.translations;
            },
            layerId: layer.id,
            get options() {
                return layer.options;
            },
            center: coords,
        };
        this.editor.functions.vueSet("layersShapes", layer.id, layerShape);
    }

    getCenterCoords(layer) {
        const [x, y] = layer.points[0];
        return { x, y };
    }

    getBBox(layer) {
        const rect = this.editor.$refs.frame.getBoundingClientRect();
        const element = document.getElementById(layer.id);
        const boundingRect = element.getBoundingClientRect();
        const { getZoom, getAspectRatio } = this.editor.getters;
        const scale = getZoom();
        const aspectRatio = getAspectRatio();
        let bbox = {
            x: ((boundingRect.x - rect.left) / scale) * aspectRatio,
            y: ((boundingRect.y - rect.top) / scale) * aspectRatio,
            width: (boundingRect.width / scale) * aspectRatio,
            height: (boundingRect.height / scale) * aspectRatio,
        };
        bbox.cx = bbox.x + bbox.width / 2;
        bbox.cy = bbox.y + bbox.height / 2;
        return bbox;
    }
}
